// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put, multipart } from '../../../../common/api'
import { ADD_ATTENDANCE, ATTENDANCE, GET_ATTENDANCE, ADD_PROFILE_ATTENDANCE } from '../../../../common/constant'

export const actionAttendance = createAsyncThunk('appAttendance/actionAttendance', async (params, thunkAPI) => {
    return await post(ATTENDANCE, params, thunkAPI)
})

export const actionAddAttendance = createAsyncThunk('appAttendance/actionAddAttendance', async (params, thunkAPI) => {
    return await put(ADD_ATTENDANCE, params, thunkAPI)
})

export const actionAddProfileAttendance = createAsyncThunk('appAttendance/actionAddProfileAttendance', async (params, thunkAPI) => {
    return await multipart(ADD_PROFILE_ATTENDANCE, params, thunkAPI)
})

export const actionGetAttendance = createAsyncThunk('appAttendance/actionGetAttendance', async (params, thunkAPI) => {
    return await post(GET_ATTENDANCE, params, thunkAPI)
})

export const appAttendanceSlice = createSlice({
    name: 'appAttendance',
    initialState: {
        //list
        loading: false,
        attendance: null,

        //add
        loadingAdd: false,
        addAttendance: null,

        //get
        loadingGet: false,
        getAttendance: null,

        //add profile
        loadingAddProfile: false,
        addAttendanceProfile: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetAttendanceResponse: (state) => {
            state.attendance = null
        },
        resetAddAttendanceResponse: (state) => {
            state.addAttendance = null
        },
        resetGetAttendanceResponse: (state) => {
            state.getAttendance = null
        },
        resetGetAttendanceProfileResponse: (state) => {
            state.addAttendanceProfile = null
        }
    },
    extraReducers: builder => {
        builder

            //list
            .addCase(actionAttendance.pending, (state) => {
                state.loading = true
            })
            .addCase(actionAttendance.fulfilled, (state, action) => {
                state.loading = false
                state.attendance = action.payload
            })
            .addCase(actionAttendance.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddAttendance.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddAttendance.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addAttendance = action.payload
            })
            .addCase(actionAddAttendance.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetAttendance.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetAttendance.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getAttendance = action.payload
            })
            .addCase(actionGetAttendance.rejected, (state) => {
                state.loadingGet = false
            })

            //get
            .addCase(actionAddProfileAttendance.pending, (state) => {
                state.loadingAddProfile = true
            })
            .addCase(actionAddProfileAttendance.fulfilled, (state, action) => {
                state.loadingAddProfile = false
                state.addAttendanceProfile = action.payload
            })
            .addCase(actionAddProfileAttendance.rejected, (state) => {
                state.loadingAddProfile = false
            })
    }
})
export const { resetAttendanceResponse, resetGetAttendanceResponse, resetAddAttendanceResponse, resetGetAttendanceProfileResponse } = appAttendanceSlice.actions

export default appAttendanceSlice.reducer